<template>
  <div v-if="value">
    <span>{{value.text}}</span>
    <br/>
    <!-- An optional second line, such as the count result being confirmed. -->
    <template v-if="value.detail"><b class="detail">{{value.detail}}</b><br/></template>
    <button v-if="value.ok" @click="ok">{{okText}}</button>
    <button v-if="value.cancel" @click="cancel">{{cancelText}}</button>
  </div>
</template>

<script>
export default {
  name: 'MessageBox',

  props: {
    value: { type: Object },
  },

  computed: {
    okText() { return this.value.okText || '确定'; },
    cancelText() { return this.value.cancelText || '取消'; },
  },

  methods: {
    ok() {
      this.value.ok();
      this.$emit('input', null);
    },

    cancel() {
      this.value.cancel();
      this.$emit('input', null);
    },
  },
}
</script>

<style scoped>
button {
  width: 100px;
  height: 40px;
}
</style>
